import settings from "./settings/settings.middleware";
import account from "./account/account.middleware";

export default [settings, account];
